<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="4">
                  <label class="mr-sm-2" for="sUsername">Username </label>
                  <b-input id="sUsername" type="text" placeholder="" v-model.trim="sUsername"></b-input>
                </b-col>
                <b-col sm="4">
                  <label class="mr-sm-2" for="sTicket">Ticket </label>
                  <b-input id="sTicket" type="text" placeholder="" v-model.trim="sTicket"></b-input>
                </b-col>
                <b-col sm="4">
                  <label class="mx-sm-2" for="sRedeemCode">Redeem Code </label>
                  <b-input id="sRedeemCode" type="text" placeholder="" v-model.trim="sRedeemCode"></b-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <label for="sDrawId">Draw&nbsp;&nbsp;</label>
                  <b-form-select id="sDrawId" :plain="false" v-model="sDrawId">
                    <option :value="null">Please select</option>
                    <option v-for="d in allDrawList" :key="`Draw-${d.Id}`" :value="d.Id">{{ d.Name }}</option>
                  </b-form-select>
                </b-col>
                <b-col sm="4">
                  <label for="sGiftId">Gift&nbsp;&nbsp;</label>
                  <b-form-select id="sGiftId" :plain="false" v-model="sGiftId">
                    <option :value="null">Please select</option>
                    <option v-for="g in gifts" :key="`Gifts-${g.Id}`" :value="g.Id">Name: {{ g.Name }}, Qty: {{ g.Quantity }}</option>
                  </b-form-select>
                </b-col>
                <b-col sm="4">
                  <label for="sStatus">Status&nbsp;&nbsp;</label>
                  <b-form-select id="sStatus" :plain="false" v-model="sStatus">
                    <option :value="null">Please select</option>
                    <option v-for="s in status" :key="`Status-${s.Id}`" :value="s.Id">{{ s.label }}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <label class="mr-sm-2" for="sStartTime">Add Time (yyyy/mm/dd 00:00:00) From</label>
                  <b-input id="sStartTime" type="date" placeholder="" v-model.trim="sStartTime"></b-input>
                </b-col>
                <b-col sm="4">
                  <label class="mr-sm-2" for="sEndTime">Add Time (yyyy/mm/dd 23:59:59) To</label>
                  <b-input id="sEndTime" type="date" placeholder="" v-model.trim="sEndTime"></b-input>
                </b-col>
                <b-col sm="4" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="searchTicket"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-tag'></i> Ticket</h3>
              <div class="float-right">
                <b-button variant="warning" @click="exportCSV">Export</b-button>
                <b-button variant="primary" @click="showCreateModal">Create Ticket</b-button>
              </div>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
              <template v-slot:cell(Ticket)="data">
                {{data.item.Ticket}}<b-button variant="link" @click="openGame(data.item.GameUrl, data.item.DomainCode, data.item.Ticket, data.item.MemberId)"><i class="fa fa-link"></i></b-button>
              </template>
              <template v-slot:cell(Win)="data">
                <b-badge v-if="data.item.Win === 0" variant="secondary">No</b-badge>
                <b-badge v-else-if="data.item.Win === 1" variant="success">Yes</b-badge>
              </template>
              <template v-slot:cell(Status)="data">
                <b-badge v-if="data.item.Status === 0" variant="success">Create</b-badge>
                <b-badge v-else-if="data.item.Status === 1" variant="warning">Draw</b-badge>
                <b-badge v-else-if="data.item.Status === 2" variant="success">Redeem</b-badge>
                <b-badge v-else-if="data.item.Status === 3" variant="info">Processing</b-badge>
                <b-badge v-else-if="data.item.Status === 4" variant="danger">Failed</b-badge>
                <b-badge v-else-if="data.item.Status === 5" variant="success">Manual</b-badge>
                <b-badge v-else-if="data.item.Status === 6" variant="danger">Duplicate Spin</b-badge>
                <b-badge v-else-if="data.item.Status === 7" variant="danger">Ticket Expired</b-badge>
              </template>
              <template v-slot:cell(action)="data">
                <!-- <b-button v-if="(data.item.Status === 1 && data.item.Win === 1) || ([3,4].includes(data.item.Status))" variant="warning" class="btn-sm" @click="confirm(data.item.Id, 'auto')">Auto Redeem</b-button><br/> -->
                <b-button v-if="(data.item.Status === 1 && data.item.Win === 1) || ([3,4].includes(data.item.Status))" variant="danger" class="btn-sm" @click="confirm(data.item.Id, 'manual')">Manual Redeem</b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal ref="createTicket" size="lg" header-bg-variant="primary" hide-footer title="Create Ticket">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!$v.searchName.$error">
                      <b-input-group>
                        <b-form-input type="text" placeholder="Enter Username for Search" v-model.trim="searchName" :state="$v.searchName.$error?false:null" @focus.native="$v.searchName.$touch"></b-form-input>
                        <b-input-group-button class="input-group-append">
                          <b-btn variant="success" @click="searchMember" :disabled="$v.searchName.$invalid">
                            <i class="fa fa-search"></i> Search
                          </b-btn>
                        </b-input-group-button>
                      </b-input-group>
                      <div v-if="$v.searchName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.searchName.required">Username is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.searchName.minLength">Must have at least {{ $v.searchName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.searchName.maxLength">Must no exceed {{ $v.searchName.$params.maxLength.max}} letters</div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="members" :fields="memberFields" :current-page="memberCurrentPage" :per-page="memberPerPage">
                      <template v-slot:cell(action)="data">
                        <b-button variant="danger" @click="confirmCreateTicket(data.item.Id)">Create Ticket</b-button>
                      </template>
                    </b-table>
                    <nav>
                      <b-pagination :total-rows="getMemberRowCount(members)" :per-page="memberPerPage" v-model="memberCurrentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                    </nav>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="outline-danger" @click="hideCreateModal">Cancel</b-btn>
    </b-modal>
    <b-modal ref="confirm" size="lg" centered header-bg-variant="primary" hide-footer title="Redeem This Ticket">
          <div class="mb-3">
            Are you sure?
          </div>
          <b-button :disabled="redeemRequest" variant="success" @click="redeemTicket">Yes</b-button>
          <b-button :disabled="redeemRequest" variant="outline-danger" @click="cancelRedeem">Cancel</b-button>
    </b-modal>
    <b-modal ref="confirmCreateTicket" size="lg" centered header-bg-variant="primary" hide-footer title="Create Ticket">
          <div class="d-block">
            <b-row>
              <b-col sm="6">
                <label for="cDomainId">Domain</label>
                <b-form-select id="cDomainId" :plain="false" v-model="cDomainId" :state="$v.cDomainId.$error?false:null" @blur.native="$v.cDomainId.$touch">
                  <option :value="null">Please select</option>
                  <option v-for="d in domains" :key="`Domain-${d.Id}`" :value="d.Id">{{ d.Code }}</option>
                </b-form-select>
                <div v-if="$v.cDomainId.$error">
                  <div class="invalid-feedback d-block" v-if="!$v.cDomainId.required">Domain is required</div>
                </div>
              </b-col>
              <b-col sm="6">
                <label for="cDrawId">Draw</label>
                <b-form-select id="cDrawId" :plain="false" v-model="cDrawId" :state="$v.cDrawId.$error?false:null" @blur.native="$v.cDrawId.$touch">
                  <option :value="null">Please select</option>
                  <option v-for="dr in draws" :key="`Draws-${dr.Id}`" :value="dr.Id">{{ dr.Name }}</option>
                </b-form-select>
                <div v-if="$v.cDrawId.$error">
                  <div class="invalid-feedback d-block" v-if="!$v.cDrawId.required">Draw is required</div>
                </div>
              </b-col>
              <b-col v-if="cDrawId" sm="6">
                <label for="cQuantity">Ticket Quantity</label>
                <b-form-input type="number" placeholder="Number of Ticket to issue" v-model.trim="cQuantity" :state="$v.cQuantity.$error ? false : null" @focus.native="$v.cQuantity.$touch"></b-form-input>
                <div v-if="$v.cQuantity.$error">
                  <div class="invalid-feedback d-block" v-if="!$v.cQuantity.required">Ticket Quantity is required</div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <br/>
                <b-button variant="success" @click="createTicket" :disabled="$v.cDomainId.$invalid || $v.cDrawId.$invalid">Create</b-button>
                <b-button variant="outline-danger" @click="cancelCreateTicket">Cancel</b-button>
              </b-col>
            </b-row>
          </div>
    </b-modal>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  const {required, minLength, maxLength} = require('vuelidate/lib/validators')
  const moment = require('moment-timezone')
  export default {
    name: 'ticket-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        members: [],
        domains: [],
        gifts: [],
        draws: [],
        allDrawList: [],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'DomainCode', label: 'Domain'},
          {key: 'DrawName', label: 'Draw'},
          {key: 'Ticket', label: 'Ticket'},
          {key: 'Username', label: 'Username'},
          {key: 'GiftName', label: 'Gift'},
          {key: 'GiftQuantity', label: 'Qty'},
          {key: 'Win', label: 'Win'},
          {key: 'Status', label: 'Status'},
          {key: 'AddTime', label: 'Add Time'},
          {key: 'ExpireTime', label: 'Expire Time'},
          {key: 'RedeemCode', label: 'Redeem Code'},
          {key: 'RedeemTime', label: 'Redeem Time'},
          {key: 'RedeemOperator', label: 'Operator'},
          {key: 'CreateOperator', label: 'Creator'},
          {key: 'action', label: 'Action'}
        ],
        memberFields: [
          {key: 'Id', label: 'ID'},
          {key: 'Username', label: 'Username'},
          {key: 'action', label: 'Action'}
        ],
        status: [
          {Id: '0', label: 'Created'},
          {Id: '1', label: 'Draw'},
          {Id: '2', label: 'Redeem'},
          {Id: '3', label: 'Processing'},
          {Id: '4', label: 'Failed'},
          {Id: '5', label: 'Manual Handle'}
        ],
        currentPage: 1,
        memberCurrentPage: 1,
        perPage: 50,
        memberPerPage: 10,
        totalMemberRows: 0,
        rowCount: 0,
        operator: 0,
        redeemId: '',
        createId: '',
        cDomainId: '',
        cDrawId: '',
        cQuantity: 0,
        searchName: '',
        sUsername: '',
        autoRedeem: 1,
        redeemRequest: false,
        sRedeemCode: '',
        sTicket: '',
        sDrawId: null,
        sGiftId: null,
        sStatus: null,
        sStartTime: moment().tz('Asia/Taipei').format('YYYY-MM-DD'),
        sEndTime: moment().tz('Asia/Taipei').format('YYYY-MM-DD')
      }
    },
    validations: {
      searchName: { required, minLength: minLength(5), maxLength: maxLength(20) },
      cDomainId: { required },
      cDrawId: { required },
      cQuantity: { required }
    },
    watch: {
      currentPage: function () {
        this.searchTicket()
      },
      currentMemberPage: function () {
        this.searchMember()
      },
      cDomainId: function () {
        this.getDraws()
      },
      cDrawId: function () {
        const draw = this.draws.find(x => (x.Id = this.cDrawId))
        this.cQuantity = draw.Quantity
      }
    },
    methods: {
      getRowCount () {
        return this.rowCount
      },
      getMemberRowCount (members) {
        return members.length
      },
      getDomains () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/domain/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.domains = response.data.domains
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getAllDrawList () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/draw/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.allDrawList = response.data.draws
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getAllGifts () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/gift/all?status=1', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.gifts = response.data.gifts
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getDraws () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/domain/draws', {domainId: this.cDomainId}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.draws = response.data.draws
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      searchMember () {
        this.$http.post(this.API_ENDPOINT + '/member/search', {searchName: this.searchName}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.members = response.data.members
          this.totalMemberRows = response.data.members.length
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      searchTicket () {
        let page = this.currentPage
        let size = this.perPage
        let username = this.sUsername
        let redeemCode = this.sRedeemCode
        let ticket = this.sTicket
        let drawId = (this.sDrawId === null) ? '' : this.sDrawId
        let giftId = (this.sGiftId === null) ? '' : this.sGiftId
        let startTime = this.sStartTime
        let endTime = this.sEndTime
        let status = (this.sStatus === null) ? '' : this.sStatus
        let queryStr = `?page=${page}&size=${size}&username=${username}&redeemCode=${redeemCode}&ticket=${ticket}&status=${status}&drawId=${drawId}&giftId=${giftId}&startTime=${startTime}&endTime=${endTime}`
        this.$http.get(this.API_ENDPOINT + '/luckywheel/ticket/search' + queryStr, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.tickets
          this.rowCount = response.data.rowCount
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      async exportCSV () {
        try {
          Events.$emit('loader')
          let username = this.sUsername
          let redeemCode = this.sRedeemCode
          let ticket = this.sTicket
          let drawId = (this.sDrawId === null) ? '' : this.sDrawId
          let giftId = (this.sGiftId === null) ? '' : this.sGiftId
          let startTime = this.sStartTime
          let endTime = this.sEndTime
          let status = (this.sStatus === null) ? '' : this.sStatus
          let queryStr = `?username=${username}&redeemCode=${redeemCode}&ticket=${ticket}&status=${status}&drawId=${drawId}&giftId=${giftId}&startTime=${startTime}&endTime=${endTime}`
          let response = await this.$http.get(this.API_ENDPOINT + '/luckywheel/ticket/search/export' + queryStr, {headers: { 'Content-Type': 'application/json' }})
          const url = window.URL.createObjectURL(new Blob([ response.data ]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `luckywheel_report_${moment(this.startTime).format('YYYYMMDD')}_${moment(this.endTime).format('YYYYMMDD')}.csv`)
          document.body.appendChild(link)
          link.click()
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        } finally {
          Events.$emit('loader')
        }
      },
      createTicket () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/ticket/create', {'domainId': this.cDomainId, 'drawId': this.cDrawId, 'quantity': this.cQuantity, 'memberId': this.createId, 'operator': this.operator}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.searchTicket()
            this.finishCreateTicket()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Ticket Created')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      redeemTicket () {
        this.redeemRequest = true
        this.$http.post(this.API_ENDPOINT + '/luckywheel/ticket/redeem', {'id': this.redeemId, 'operator': this.operator, auto: this.autoRedeem}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.redeemRequest = false
          if (response.status === 200) {
            this.searchTicket()
            this.cancelRedeem()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Ticket Redeemed')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          this.redeemRequest = false
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      openGame (gameUrl, domainCode, ticket, memberId) {
        window.open(gameUrl + ((new URL(gameUrl)).search ? '&' : '?') + 'dCode=' + domainCode + '&tId=' + ticket + '&mId=' + memberId)
      },
      confirm (id, type) {
        this.redeemId = id
        this.autoRedeem = type === 'auto'
        this.$refs.confirm.show()
      },
      confirmCreateTicket (id) {
        this.createId = id
        this.$refs.confirmCreateTicket.show()
      },
      cancelRedeem () {
        this.$refs.confirm.hide()
      },
      cancelCreateTicket () {
        this.$refs.confirmCreateTicket.hide()
        this.$refs.createTicket.show()
      },
      finishCreateTicket () {
        this.$refs.confirmCreateTicket.hide()
      },
      showCreateModal () {
        this.reset()
        this.$refs.createTicket.show()
      },
      hideCreateModal () {
        this.$refs.createTicket.hide()
      },
      reset () {
        this.searchName = ''
        this.members = []
      }
    },
    created () {
      let user = JSON.parse(window.sessionStorage.getItem('user'))
      this.operator = user.username
      this.getDomains()
      this.getAllGifts()
      this.getAllDrawList()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/ticket/TicketTable.vue